import { Controller } from "@hotwired/stimulus"

// Manages multi-step navigation within the ToS compliance modal.
// Targets:
//   step        — each step container (one per policy type)
//   progress    — the step counter text, e.g. "Step 1 of 3"
//   backButton  — the Back button (hidden on step 1)
export default class extends Controller {
  static targets = ["step", "progress", "backButton"]

  connect() {
    this.currentIndex = 0
    this.#showStep(this.currentIndex)
  }

  next() {
    if (this.currentIndex < this.stepTargets.length - 1) {
      this.currentIndex++
      this.#showStep(this.currentIndex)
    }
  }

  back() {
    if (this.currentIndex > 0) {
      this.currentIndex--
      this.#showStep(this.currentIndex)
    }
  }

  #showStep(index) {
    this.stepTargets.forEach((step, i) => {
      step.hidden = i !== index
    })

    if (this.hasProgressTarget) {
      this.progressTarget.textContent = `Step ${index + 1} of ${this.stepTargets.length}`
    }

    if (this.hasBackButtonTarget) {
      this.backButtonTarget.hidden = index === 0
    }
  }
}
